import * as React from 'react';

export const CircleUpArrow = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z'
      fill='#C3C6C8'
    />
    <path d='M8 13.98L11.99 10L16 14' stroke='#272E34' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
